module.exports = __webpack_public_path__ + "static/media/no_connection.1e2742e5.jpg";